import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { serialize } from "../modules/form_fields"

export default class extends Controller {
  static values = {
    url: String,
    formId: String
  }

  initialize() {
  }

  click(event) {
    event.preventDefault()

    // parse params or object and encodes/escapes  
    let params = new URLSearchParams()   
    let form = document.getElementById(this.formIdValue)
    serialize(form, params);

    post(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream"
    })
  }
}